<mat-toolbar color="accent">Select Verifone Terminal</mat-toolbar>

<mat-dialog-content>
  <mat-action-list>
    @for (option of options$ | async; track option.terminal.ref.path) {
      <button mat-list-item (click)="select(option)">
        <mat-icon matListItemIcon>point_of_sale</mat-icon>
        <span matListItemTitle>{{ option.terminal.name }}</span>
        <span matListItemLine>{{ option.terminal.serialNumber }}</span>
      </button>
    } @empty {
      <p class="p-4 text-center text-gray-500">
        No paired terminals available. Please pair a terminal first.
      </p>
    }
  </mat-action-list>
</mat-dialog-content>

<mat-dialog-actions>
  <pt-buttons-container padding="none">
    <button type="button" mat-stroked-button mat-dialog-close>Cancel</button>
  </pt-buttons-container>
</mat-dialog-actions>
